import StatData from '../data/StatData'

export const round2Dp = (value) => Math.round(value * 100) / 100

export const getPlayerVisibleName = (player) =>
  player.player_known_name ? player.player_known_name : player.player_name

export const playerStatFieldNames = (stats) =>
  Object.keys(stats).filter(
    (statName) => !statName.includes('team') && !statName.includes('_id')
  )

export const matchStatFieldNames = (stats) =>
  Object.keys(stats).filter(
    (statName) =>
      !statName.includes('team') &&
      !statName.includes('_id') &&
      statName !== 'goals' &&
      statName !== 'minutes_played' &&
      !statName.includes('player')
  )

export const getPlayerStatMap = (match, teamId, playerId) =>
  StatData.filter((stat) => (match ? stat.match_id === match.match_id : true))
    .filter((stat) => (teamId ? stat.team_id === teamId : true))
    .filter((stat) => (playerId ? stat.player_id === playerId : true))
    .reduce((statsMap, stats) => {
      const item = statsMap.get(stats.player_id)
        ? incrementStats(
            statsMap.get(stats.player_id),
            stats,
            playerStatFieldNames(stats)
          )
        : Object.assign({}, stats, { ...stats })

      return statsMap.set(stats.player_id, item)
    }, new Map())

export const getMatchStatMap = (match) =>
  StatData.filter((stats) => stats.match_id === match.match_id).reduce(
    (statsMap, stats) => {
      const item = statsMap.get(stats.team_id)
        ? incrementStats(
            statsMap.get(stats.team_id),
            stats,
            matchStatFieldNames(stats)
          )
        : Object.assign({}, stats, { ...stats })

      return statsMap.set(stats.team_id, item)
    },
    new Map()
  )

const incrementStats = (stats, otherStats, fieldNames) => {
  const newStats = { ...stats }
  fieldNames.forEach(
    (fieldName) =>
      (newStats[fieldName] = round2Dp(stats[fieldName] + otherStats[fieldName]))
  )
  return newStats
}

export const getPossessionData = (match) =>
  new Map(
    stripDuplicates(
      StatData.filter((stats) => stats.match_id === match.match_id),
      'team_id'
    )
      .map((stats) => ({
        team_id: stats.team_id,
        possession: Math.round(stats.team_possession_percentage * 100)
      }))
      .map((key) => [key.team_id, key.possession])
  )

export const stripDuplicates = (arr, fieldName) =>
  arr.filter(
    (value, index, self) =>
      self.map((x) => x[fieldName]).indexOf(value[fieldName]) === index
  )
